<template>
    <div class="modal modal-info fade" :id="modalId" tabindex="-1" role="dialog" :aria-labelledby="modalId" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4>{{ title }}</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    </button>
                </div>
                <div class="modal-body">
                    <div class="modal-inner">
                        <div class="text-scroll">
                            <p>{{modalText}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'EyesShowModal',
    props: {
        modalText: String,
        title: String,
        modalId: String,
    }

}

</script>

<style scoped>

</style>
